// types.js

export const userPermissionActionTypes = {
    SET_USER_PERMISSIONS: 'SET_USER_PERMISSIONS',
    CLEAR_USER_PERMISSIONS: 'CLEAR_USER_PERMISSIONS'
}

// Other action types can also be defined here
